import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  SearchContext,
  SearchValueContext,
  SearchSetValueContext,
} from "contexts/searchContext";

const SearchProvider = (props) => {
  const { children } = props;
  const [searchValue, setSearchValue] = useState("");
  const [withSearch, setWithSearch] = useState({
    enabled: false,
    placeholder: "",
  });

  return (
    <SearchContext
      value={{
        search: withSearch,
        setSearch: setWithSearch,
        onSearch: () => {},
      }}
    >
      <SearchSetValueContext value={setSearchValue}>
        <SearchValueContext value={searchValue}>{children}</SearchValueContext>
      </SearchSetValueContext>
    </SearchContext>
  );
};

SearchProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SearchProvider;
